import "./utils/useTranslation.js";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.rtl.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
import "../src/style/scss/main.scss";
import "../src/customStyle.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/fonts/feather/css/iconfont.css";
import { createRoot } from "react-dom/client";
import "./i18n";
import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import langData from "./utils/lang.json";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "antd/dist/reset.css";

const rootElement = document.getElementById("root");

// global translator helper
window.translate = (key) => {
  const lang = localStorage.getItem("lang") || "en";
  return langData?.[key]?.[lang] || langData?.[key]?.["en"] || key;
};

if (rootElement) {
  const root = createRoot(rootElement);

  const AppContent = (
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <AllRoutes />
        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </Provider>
  );

  // render
  if (process.env.NODE_ENV === "development") {
    root.render(AppContent);
  } else {
    root.render(<React.StrictMode>{AppContent}</React.StrictMode>);
  }
} else {
  console.error("Element with id 'root' not found.");
}
